<template>
    <div v-if="show">
        <h2 class="title is-2 section-header">
            Remove facility from all code sets
        </h2>
        <div class="block">
            <p class="block">
                Remove facility from all code sets.
            </p>
            <p class="block">
                Code set memberships and code set description will be updated.
            </p>
            <b-field label="Facility name">
                <b-input v-model="facilityName" />
            </b-field>
            <b-field>
                <b-switch v-model="dryRun">
                    Dry run (rollback transaction)
                </b-switch>
            </b-field>
        </div>
        <div class="buttons">
            <b-button
                type="is-primary"
                :disabled="!enabled"
                @click="run()">
                Run
            </b-button>
            <b-button
                :disabled="!enabled"
                @click="cancelCommand()">
                Cancel
            </b-button>
        </div>
    </div>
</template>

<script>
    import runMixin from './RunMixin.js';

    export default {
        mixins: [runMixin],
        data() {
            return {
                facilityName: '',
                dryRun: true
            };
        },
        methods: {
            async run() {
                await this.submitCommand([
                    'delete-facility-codesets',
                    this.facilityName,
                    this.dryRun ? 'dry-run' : ''
                ]);
            }
        }
    };
</script>
